/*jshint esversion: 6 */

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('header.sticky-top');
    const breakpoint = 992;
    const scrollThreshold = 49;
    let isMobile = window.innerWidth < breakpoint;

    const toggleHeaderClass = () => {
        if (window.scrollY > scrollThreshold) {
            header.classList.add('is-pinned');
        } else {
            header.classList.remove('is-pinned');
        }
    };

    const moveElements = () => {
        const currentMobileState = window.innerWidth < breakpoint;
        if (currentMobileState !== isMobile) {
            isMobile = currentMobileState;
        }

        const elementsToMove = [
            { element: 'header-cta-wrapper', desktop: 'header-cta-desktop', mobile: 'header-cta-mob' }
        ];

        elementsToMove.forEach(({ element, desktop, mobile }) => {
            const target = document.getElementById(element);
            const newParent = isMobile ? document.getElementById(mobile) : document.getElementById(desktop);
            if(target != null){
                newParent.appendChild(target);
            }
            console.log(`Moved to ${isMobile ? 'mobile' : 'desktop'}`);
        });
    };

    const debounce = (func, delay) => {
        let inDebounce;
        return function() {
            const context = this;
            const args = arguments;
            clearTimeout(inDebounce);
            inDebounce = setTimeout(() => func.apply(context, args), delay);
        };
    };

    // Initialize
    toggleHeaderClass();
    moveElements();

    // Event listeners
    window.addEventListener('scroll', toggleHeaderClass);
    window.addEventListener('resize', debounce(moveElements, 100));



    // move form inside the form wrapper
    const contactFormWrapper = document.querySelector('body:not(.dnnEditState) #form-extra-content');
    const contactForm = document.querySelector('body:not(.dnnEditState) #dnn_BottomFormPane .LiveForm.Default');
    const contactFormTarget = document.querySelector('body:not(.dnnEditState) #js-form-target');

    if (contactForm && contactFormTarget) {
        contactFormTarget.appendChild(contactForm);
    }
});